var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.244,
    height: 135.13,
    viewBox: "0 0 155.244 135.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 99,
    height: 99,
    transform: "translate(0 -0.297)",
    fill: "#004c97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(-53.464 -720.445)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 8,
    cy: 7.5,
    rx: 8,
    ry: 7.5,
    transform: "translate(182 765)",
    fill: "#e63036"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(69.002 711.891) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 26.368,
    transform: "translate(0 12.598)",
    fill: "none",
    stroke: "#004c97",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 26.368,
    transform: "translate(12.648 0) rotate(90)",
    fill: "none",
    stroke: "#004c97",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(202.139 815.177) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_11-2",
    "data-name": "Line 11",
    x2: 17.579,
    transform: "translate(0 8.789)",
    fill: "none",
    stroke: "#004c97",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12-2",
    "data-name": "Line 12",
    x2: 17.579,
    transform: "translate(8.789 0) rotate(90)",
    fill: "none",
    stroke: "#004c97",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 10.987,
    height: 10.987,
    transform: "translate(61.233 840.037) rotate(45)",
    fill: "#004c97"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(79.856 737.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M97.911,61.1,79.424,54.94V36.5a26.68,26.68,0,0,0-3.1-12.485L91.935,8.4a1.159,1.159,0,1,0-1.642-1.635L75.11,21.953A26.957,26.957,0,0,0,60.141,10.747V1.157a1.155,1.155,0,1,0-2.31,0v9.009a26.854,26.854,0,0,0-5.266-.527H46.139a26.944,26.944,0,0,0-5.272.527V1.157a1.157,1.157,0,1,0-2.313,0v9.59A26.953,26.953,0,0,0,23.592,21.953L8.4,6.766A1.156,1.156,0,0,0,6.766,8.4L22.377,24.013A26.677,26.677,0,0,0,19.28,36.5V54.94L.793,61.1a1.157,1.157,0,0,0,.363,2.255,1.123,1.123,0,0,0,.366-.061L19.28,57.381V68.626a26.677,26.677,0,0,0,3.1,12.485L6.766,96.723A1.157,1.157,0,0,0,8.4,98.361l15.19-15.19A26.838,26.838,0,0,0,46.139,95.486h6.426A26.833,26.833,0,0,0,75.11,83.171L90.3,98.358a1.16,1.16,0,1,0,1.642-1.639L76.327,81.108a26.718,26.718,0,0,0,3.1-12.485V57.378L97.179,63.3a1.123,1.123,0,0,0,.366.061,1.158,1.158,0,0,0,.366-2.255M46.139,11.952h6.426A24.556,24.556,0,0,1,77.05,35.341h-55.4A24.709,24.709,0,0,1,41.526,12.387a23.95,23.95,0,0,1,4.614-.435M21.59,68.626V37.654H48.2V93.172H46.139A24.575,24.575,0,0,1,21.59,68.626M52.565,93.172H50.506V37.654h26.6V68.626A24.572,24.572,0,0,1,52.565,93.172",
    transform: "translate(0 0)",
    fill: "#004c97"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.10dd90da5182b61fdb46e6af81077f78.svg";
export { ForwardRef as ReactComponent };